(function(angular){
    'use strict';

    // TODO: move to separate module that has models
    // provides standard values for age and gender to be used with imo requests
    angular.module('aprima-legacy-common').factory('ImoPatient', [
        '_',
        'DateUtilities',
        'ObjUtil',
        ImoPatientFactory
    ]);

    function ImoPatientFactory(
        _,
        DateUtilities,
        ObjUtil
    ) {

        var femaleRegex = /^f(emale)?$/i;
        var maleRegex = /^m(ale)?$/i;

        ImoPatient.mapFromApi = mapFromApi;
        return ImoPatient;

        function ImoPatient(name, ageInYears, gender) {
            var standardizedAge = null;
            ageInYears = parseFloat(ageInYears);
            if(!_.isNaN(ageInYears) && ageInYears >= 0) {
                standardizedAge = _.round(ageInYears);
            }

            var standardizedGender = null;
            if(femaleRegex.test(gender)) {
                standardizedGender = 'F';
            }
            else if(maleRegex.test(gender)) {
                standardizedGender = 'M';
            }

            ObjUtil.defineReadonlyProps(this, {
                name: name,
                age: ageInYears,
                standardizedAge: standardizedAge,
                hasAge: !!standardizedAge || standardizedAge === 0,
                gender: gender,
                standardizedGender: standardizedGender,
                hasGender: !!standardizedGender,
            });
        }

        function mapFromApi(patient) {
            if(!patient) {
                return null;
            }

            var name = patient.FirstName + ' ' + patient.LastName;

            // BirthDate from PatientDto, DateOfBirth from PatientHeaderDetailsDto
            var birthDate = patient.BirthDate || patient.DateOfBirth;
            // only PatientDto has DeathDate
            var deathDate = patient.DeathDate;
            var ageInfo = DateUtilities.getPersonAge(birthDate, deathDate, 'years');

            // Gender from PatientDto, GenderName and GenderAnsi from PatientHeaderDetailsDto
            var gender = patient.Gender || patient.GenderName || patient.GenderAnsi;

            return new ImoPatient(name, ageInfo.age, gender);
        }
    }

})(window.angular);
